import { TransferCreate } from "./TransferCreate";
import { TransferEdit } from "./TransferEdit";
import { TransferList } from "./TransferList";
import { TransferShow } from "./TransferShow";

export default {
  list: TransferList,
  create: TransferCreate,
  edit: TransferEdit,
  show: TransferShow,
};
